import React, { useEffect, useState } from "react";
import { Card, Form, Row, Col, Button } from "react-bootstrap";
import * as apicall from "../../components/Apicall";
import { toast } from "react-toastify";
import Select from "react-select";

const CompanyInformation = () => {
  const [products, setProducts] = useState([]);
  const [types, setTypes] = useState([]);
  const userDetails = JSON.parse(localStorage.getItem("user_details"));
  const user_id = userDetails?.id;
const [companyDetails, setCompanyDetails] = useState(null);

  // Initialize form with company details (use names for pre-fill)
  const [form, setForm] = useState({
    name: "",
    registration_no:"",
    tax_id: "",
    country: "",
    type: "",
    address: "",
    industry: ""
  });

  useEffect(() => {
    getProductList();
    getTypes();
    fetchCompanyDetails();
  }, []);
const fetchCompanyDetails = async () => {
  const res = await apicall.get(`getCompanyDetails?user_id=${user_id}`);
  console.log(res, "res");

  if (res.success && res.data) {
    const data = res.data;

    // <-- MISSING EARLIER
    setCompanyDetails(data);  // VERY IMPORTANT

    setForm({
      name: data.company_name || "",
      registration_no: data.registration_no || "",
      tax_id: data.tax_id || "",
      country: data.country || "",
      type: data.type_name || "",
      address: data.address || "",
      industry: (data.products || []).map(p => p.name),
    });
  }
};


  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    if (!form.name || !form.registration_no || !form.tax_id || !form.country || !form.type || !form.address) {
      toast.error("Please fill all fields");
      return;
    }

    try {
      // Map type name to type ID
      const typeId = types.find(t => t.name === form.type)?.id;

      // Map product names to product IDs
      const industryIds = products
        .filter(p => form.industry.includes(p.name))
        .map(p => p.id);

      const body = {
        user_id,
        name: form.name,
        registration_no: form.registration_no,
        tax_id: form.tax_id,
        country: form.country,
        type: typeId, // send ID to backend
        address: form.address,
        industry: industryIds, // send IDs to backend
      };

      // If company_profile_id exists, call update API; else add API
      const apiEndpoint = companyDetails?.company_profile_id ? "updateCompany" : "add-users";
      const res = await apicall.post(body, apiEndpoint);

      if (res.success) {
        toast.success("Profile Updated");
        // localStorage.setItem("company_details", JSON.stringify({ ...companyDetails, ...body }));
        setForm(prev => ({ ...prev, industry: [] }));
      }
    } catch (e) {
      toast.error("Error updating profile");
    }
  };

  const getProductList = async () => {
    try {
      const res = await apicall.get("get_products");
      setProducts(res.data || []);
    } catch (e) {
      toast.error("Could not load products");
    }
  };

  const getTypes = async () => {
    try {
      const res = await apicall.get("get_types");
      setTypes(res.data || []);
    } catch (e) {
      toast.error("Could not load types");
    }
  };

  return (
    <div className="container mt-4">
      <Card className="p-4">
        <h5>Company Information</h5>
        <p className="text-muted">Update your company details</p>

        <Form>
          <Row className="mb-3">
            <Col md={4}>
              <Form.Group>
                <Form.Label>Company Name</Form.Label>
                <Form.Control name="name" value={form.name} onChange={handleChange} />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group>
                <Form.Label>Registration Number</Form.Label>
                <Form.Control name="registration_no" value={form.registration_no} onChange={handleChange} />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group>
                <Form.Label>Tax ID</Form.Label>
                <Form.Control name="tax_id" value={form.tax_id} onChange={handleChange} />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={4}>
              <Form.Group>
                <Form.Label>Country</Form.Label>
                <Form.Control name="country" value={form.country} onChange={handleChange} />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group>
                <Form.Label>Type</Form.Label>
                <Form.Select name="type" value={form.type} onChange={handleChange}>
                  <option value="">Select Type</option>
                  {types?.map(t => (
                    <option key={t.id} value={t.name}>{t.name}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group>
                <Form.Label>Industry</Form.Label>
                <Select
                  isMulti
                  options={products.map(p => ({ value: p.name, label: p.name }))}
                  value={products
                    .filter(p => form.industry.includes(p.name))
                    .map(p => ({ value: p.name, label: p.name }))}
                  onChange={selected =>
                    setForm({ ...form, industry: selected.map(s => s.value) })
                  }
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col>
              <Form.Group>
                <Form.Label>Address</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  name="address"
                  value={form.address}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Button variant="danger" onClick={handleSave}>
            Save Changes
          </Button>
        </Form>
      </Card>
    </div>
  );
};

export default CompanyInformation;
